/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import React, { useState, useEffect } from "react";
import { Table, Space, Button, Tooltip, message, Input, Modal } from "antd";
import useCustomNavigate from "../../../components/customNavigationHook";
import "./rtoRequestsList.scss";
import { ReactComponent as View_icon } from "../../../assests/images/SVG/view-details.svg";
import { ReactComponent as Cross } from "../../../assests/images/SVG/cross.svg";
import API from "../../../api";
import urls from "../../../api/urls";
import moment from "moment";
import { getUserAndPremiseId } from "../../../utils";
import search_icon from "../../../assests/images/search-icon.svg";

const RTORequestsList = ({ tabValue }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useCustomNavigate();
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [pageNum, setPageNum] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchShipments();
  }, [tabValue]);

  const fetchShipments = async (p1 = 100, p2 = 0, customParams) => {
    setLoading(true);
    try {
      let queryParams;
      if (customParams) {
        queryParams = customParams;
      } else {
        queryParams = new URLSearchParams({
          page: (p2 + 1).toString(),
          limit: p1.toString(),
          status: "RTO_REQUESTED",
        });
      }

      const result = await API.Api(
        `${urls.GET_ORDER_BY_STATUS}?${queryParams.toString()}`,
      ).get();
      const response = result?.response?.data?.data;

      if (response) {
        // Prefer total records if provided, otherwise derive from totalPages * limit
        const metaTotal = response?.metadata?.total;
        const metaTotalPages = response?.metadata?.totalPages;
        const metaLimit = response?.metadata?.limit || p1;
        const computedTotal =
          typeof metaTotal === "number" && metaTotal > 0
            ? metaTotal
            : typeof metaTotalPages === "number" && metaTotalPages > 0
              ? metaTotalPages * metaLimit
              : (response?.orders || []).length;

        setTotal(computedTotal);
        // Keep UI page size in sync with API response when provided
        if (typeof response?.metadata?.limit === "number") {
          setPageSize(response.metadata.limit);
        }
        setData(response?.orders || []);
        // Clear selections when data changes
        setSelectedRowKeys([]);
        setSelectedRows([]);
      }
    } catch (error) {
      console.error("Error fetching shipments:", error);
    } finally {
      setLoading(false);
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const handleView = (record) => {
    navigate(`/rto-shipments-details/${record.awbNumber}`);
  };

  const rejectRTO = async (record) => {
    try {
      setLoading(true);
      const response = await API.Api(urls.RTO_REQUEST_REJECT).post({
        awbNumbers: record.awbNumber,
      });
      if (response.status) {
        message.success("RTO request rejected successfully");
        fetchShipments();
      } else {
        message.error(
          response?.response?.data?.message ||
            response?.response?.statusText ||
            "Failed to reject RTO request",
        );
      }
    } catch (error) {
      console.error("Error rejecting RTO request:", error);
      message.error(
        error?.response?.data?.message || "Failed to reject RTO request",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleReject = (record) => {
    Modal.confirm({
      title: "Confirm RTO Rejection",
      content: `Are you sure you want to reject RTO request for AWB: ${record?.awbNumber}?`,
      okText: "Yes",
      cancelText: "No",
      onOk: () => rejectRTO(record),
      centered: true,
      maskClosable: true,
    });
  };

  const approveRTO = async (record) => {
    try {
      setLoading(true);
      const userInfo = getUserAndPremiseId();
      const userName = `${userInfo?.firstName || ""} ${
        userInfo?.lastName || ""
      }`.trim();

      const userData = JSON.parse(
        sessionStorage.getItem("userId") || localStorage.getItem("userId"),
      );
      const premiseName = userData?.premises?.premiseName || "";

      const response = await API.Api(urls.RTO_REQUEST_APPROVE).post({
        awbNumbers: [record.awbNumber],
        userName: userName,
        premiseName: premiseName,
      });
      if (response.status) {
        message.success("RTO request approved successfully");
        fetchShipments();
      } else {
        message.error(
          response?.response?.data?.message ||
            response?.response?.statusText ||
            "Failed to approve RTO request",
        );
      }
    } catch (error) {
      console.error("Error approving RTO request:", error);
      message.error(
        error?.response?.data?.message || "Failed to approve RTO request",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = (record) => {
    Modal.confirm({
      title: "Confirm RTO Approval",
      content: `Are you sure you want to approve RTO request for AWB: ${record?.awbNumber}?`,
      okText: "Yes",
      cancelText: "No",
      onOk: () => approveRTO(record),
      centered: true,
      maskClosable: true,
    });
  };

  // Bulk Actions
  const bulkApproveRTO = async (awbNumbers) => {
    try {
      setLoading(true);
      const userInfo = getUserAndPremiseId();
      const userName = `${userInfo?.firstName || ""} ${
        userInfo?.lastName || ""
      }`.trim();

      const userData = JSON.parse(
        sessionStorage.getItem("userId") || localStorage.getItem("userId"),
      );
      const premiseName = userData?.premises?.premiseName || "";

      const response = await API.Api(urls.RTO_REQUEST_APPROVE).post({
        awbNumbers: awbNumbers,
        userName: userName,
        premiseName: premiseName,
      });
      if (response.status) {
        message.success(
          `${awbNumbers.length} RTO requests approved successfully`,
        );
        fetchShipments();
        setSelectedRowKeys([]);
        setSelectedRows([]);
      } else {
        message.error(
          response?.response?.data?.message ||
            response?.response?.statusText ||
            "Failed to approve RTO requests",
        );
      }
    } catch (error) {
      console.error("Error approving RTO requests:", error);
      message.error(
        error?.response?.data?.message || "Failed to approve RTO requests",
      );
    } finally {
      setLoading(false);
    }
  };

  const bulkRejectRTO = async (awbNumbers) => {
    try {
      setLoading(true);
      const response = await API.Api(urls.RTO_REQUEST_REJECT).post({
        awbNumbers: awbNumbers,
      });
      if (response.status) {
        message.success(
          `${awbNumbers.length} RTO requests rejected successfully`,
        );
        fetchShipments();
        setSelectedRowKeys([]);
        setSelectedRows([]);
      } else {
        message.error(
          response?.response?.data?.message ||
            response?.response?.statusText ||
            "Failed to reject RTO requests",
        );
      }
    } catch (error) {
      console.error("Error rejecting RTO requests:", error);
      message.error(
        error?.response?.data?.message || "Failed to reject RTO requests",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleBulkApprove = () => {
    const awbNumbers = selectedRows.map((row) => row.awbNumber);
    Modal.confirm({
      title: "Confirm Bulk RTO Approval",
      content: `Are you sure you want to approve ${selectedRows.length} RTO requests?`,
      okText: "Yes",
      cancelText: "No",
      onOk: () => bulkApproveRTO(awbNumbers),
      centered: true,
      maskClosable: true,
    });
  };

  const handleBulkReject = () => {
    const awbNumbers = selectedRows.map((row) => row.awbNumber);
    Modal.confirm({
      title: "Confirm Bulk RTO Rejection",
      content: `Are you sure you want to reject ${selectedRows.length} RTO requests?`,
      okText: "Yes",
      cancelText: "No",
      onOk: () => bulkRejectRTO(awbNumbers),
      centered: true,
      maskClosable: true,
    });
  };

  // Row selection configuration
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRows(selectedRows);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      if (selected) {
        // Select all rows
        const allKeys = data.map((item) => item.awbNumber);
        setSelectedRowKeys(allKeys);
        setSelectedRows(data);
      } else {
        // Deselect all rows
        setSelectedRowKeys([]);
        setSelectedRows([]);
      }
    },
    onSelect: (record, selected, selectedRows) => {
      const newSelectedRowKeys = selected
        ? [...selectedRowKeys, record.awbNumber]
        : selectedRowKeys.filter((key) => key !== record.awbNumber);

      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: false,
      name: record.awbNumber,
    }),
  };

  const columns = [
    {
      title: "AWB Number",
      dataIndex: "awbNumber",
      key: "awbNumber",
    },
    {
      title: (
        <>
          Request for RTO
          <br />
          Received On
        </>
      ),
      dataIndex: "orderUpdatedAt",
      key: "orderUpdatedAt",
      render: (text) => moment(text).format("DD/MM/YYYY hh:mm A") || "N/A",
    },
    {
      title: "Hub Name",
      dataIndex: "hubName",
      key: "hubName",
      render: (text) => text || "N/A",
    },
    {
      title: "Supervisor Name",
      dataIndex: "contactPersonName",
      key: "contactPersonName",
      render: (text) => text || "N/A",
    },
    {
      title: (
        <>
          Supervisor
          <br />
          Mobile no.
        </>
      ),
      dataIndex: "contactPersonPhone",
      key: "contactPersonPhone",
      render: (text) => text || "N/A",
    },
    {
      title: "Delivery Attempted On",
      dataIndex: "deliveryAttemptedOn",
      key: "deliveryAttemptedOn",
      render: (text, record) =>
        record?.rtoDetails?.deliveryAttemptedOn
          ? moment(record?.rtoDetails?.deliveryAttemptedOn).format(
              "DD/MM/YYYY hh:mm A",
            )
          : "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title={"View Details"} placement="bottom">
            <p
              className="pointer"
              style={{ marginTop: "4px", marginBottom: "0" }}
              onClick={() => handleView(record)}
            >
              <View_icon />
            </p>
          </Tooltip>
          <Button
            type="primary"
            danger
            onClick={() => handleReject(record)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 10px",
            }}
          >
            <Cross />
          </Button>
          <Button type="primary" onClick={() => handleApprove(record)}>
            APPROVE
          </Button>
        </Space>
      ),
    },
  ];

  const handlePageChange = (pagination) => {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);

    const queryParams = {
      page: pagination.current.toString(),
      limit: pagination.pageSize.toString(),
      status: "RTO_REQUESTED",
    };

    if (searchText) {
      queryParams.awbNumber = searchText;
    }

    fetchShipments(
      pagination.pageSize,
      pagination.current - 1,
      new URLSearchParams(queryParams),
    );
  };

  const onSearch = async (e) => {
    const searchQuery = e.target.value;
    setSearchText(searchQuery);
    const defaultLimit = 100;

    if (searchQuery) {
      const queryParams = new URLSearchParams({
        page: "1",
        limit: defaultLimit.toString(),
        awbNumber: searchQuery,
        status: "RTO_REQUESTED",
      });
      fetchShipments(defaultLimit, 0, queryParams);
    } else {
      fetchShipments(defaultLimit, 0);
    }
  };

  return (
    <div className="rto-shipments-list master-main-container m-1 p-1">
      <div className="p-1 rto-actions-header">
        <div className="bulk-actions">
          {selectedRowKeys.length > 0 ? (
            <div className="bulk-action-buttons">
              <span className="selected-count">
                {selectedRowKeys.length} item
                {selectedRowKeys.length > 1 ? "s" : ""} selected
              </span>
              <Button
                type="primary"
                danger
                onClick={handleBulkReject}
                disabled={loading}
                className="bulk-reject-btn"
              >
                Bulk Reject ({selectedRowKeys.length})
              </Button>
              <Button
                type="primary"
                onClick={handleBulkApprove}
                disabled={loading}
                className="bulk-approve-btn"
              >
                Bulk Approve ({selectedRowKeys.length})
              </Button>
            </div>
          ) : (
            <div className="bulk-info-message">
              <span className="info-text">
                💡 Select shipments using checkboxes to enable bulk
                approve/reject actions
              </span>
            </div>
          )}
        </div>
        <div className="search-section">
          <Input
            placeholder="Search by AWB Number"
            bordered
            style={{ borderRadius: "5px", height: "40px", width: "465px" }}
            suffix={<img src={search_icon} />}
            onChange={(e) => {
              onSearch(e);
            }}
          />
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="awbNumber"
        rowSelection={rowSelection}
        pagination={{
          pageSize: pageSize,
          total: total,
          itemRender: itemRender,
          current: pageNum == 0 ? +1 : pageNum,
        }}
        onChange={handlePageChange}
      />
    </div>
  );
};

export default RTORequestsList;
